import pxToRem from "assets/theme/functions/pxToRem";

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(250),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: {
      width: pxToRem(250),
      background: "linear-gradient(180deg, #00ACC4 0%, #2F36CB 100%)",
      height: "100vh",
      margin: 0,
      borderRadius: 0,
      border: "none",
      boxShadow: "2px 0 10px rgb(5 54 183 / 50%)",
      color: "#FFFFFF",
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
